/**
 * Site-wide editable copy.
 *
 * To update the homepage hero, contact section, and footer text, edit values
 * here. No JSX, no logic — just strings and links.
 */

export const site = {
  // Identity
  name: 'Matt Finnis',
  role: 'Lead Product & UX Designer',
  shortName: 'Matt',
  initials: 'MF',
  location: 'United Kingdom',

  // Hero
  hero: {
    eyebrow: 'Portfolio · 2026',
    headline:
      'Helping clients to provide enjoyable and accessible digital experiences.',
    intro:
      'I lead product and UX design across e-commerce, design systems, data-driven UX, and accessibility. I focus on solving complex problems and guiding teams to create user-centered solutions for clients.',
    primaryCta: { label: 'View case studies', href: '#case-studies' },
    secondaryCta: { label: 'Get in touch', href: '#contact' },
  },

  // Quick stats / capabilities (used on homepage)
  capabilities: [
    {
      title: 'E-commerce',
      detail:
        'Guiding customers through informed shopping journeys, that lift conversion and AOV without sacrificing brand.',
    },
    {
      title: 'Design systems',
      detail:
        'Tokenised, themable design systems, aligning distributed teams around a shared direction, for consistent design language.',
    },
    {
      title: 'Data-driven UX',
      detail:
        'Using research insights to inform decisions, continuously improving experiences through measurement, testing, and iteration.',
    },
    {
      title: 'Accessibility',
      detail:
        'Ensuring WCAG and EAA compliance, enhancing usability for everyone.',
    },
  ],

  // Personal interests and hobbies (shown in about section)
  hobbies: [
    {
      title: 'Photography',
      detail:
        'Exploring landscapes and capturing light in unexpected places. Particularly drawn to film photography and the deliberate, thoughtful process it requires.',
    },
    {
      title: 'Cycling',
      detail:
        'Long-distance touring and gravel riding through the UK countryside. The perfect way to disconnect from screens and find inspiration in new routes.',
    },
    {
      title: 'Cooking',
      detail:
        'Experimenting with seasonal ingredients and exploring different cuisines. Food brings people together—hosting dinner parties is my favorite way to spend weekends.',
    },
    {
      title: 'Reading',
      detail:
        'Across fiction, design history, and philosophy. Currently working through books on systems thinking and how they apply to both design and life.',
    },
  ],

  // Contact
  contact: {
    eyebrow: 'Get in touch',
    headline: 'Let’s build something that performs.',
    intro:
      'Get in touch using the form, or contact me using the options below:',
    email: 'mattfinnis@gmail.com',
    linkedin: 'https://www.linkedin.com/in/matthewfinnis/',
    showForm: true,
  },

  // Footer
  footer: {
    tagline: 'Lead Product and UX Designer.',
    copyright: `© ${new Date().getFullYear()} Matt Finnis. All rights reserved.`,
  },
} as const;

export type Site = typeof site;
